// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadImageModal_image__30F2L","upload-image-container":"UploadImageModal_upload-image-container__3I9qN"};